var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsDesktopVd(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7409.35 4562.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:lime;}.cls-2{fill:#00e767;}.cls-3{fill:#ccc;}.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "512.63 2270.66 512.63 2307.65 216.72 2307.65 216.72 496.23 1585.74 496.23 1585.74 532.22 1658.19 532.22 1658.19 2270.66 512.63 2270.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2306.67 2223.87 2306.67 2260.86 2047.75 2260.86 2047.75 486.41 3304.96 485.93 3305.73 702.35 3489.98 702.84 3489.23 2223.87 2306.67 2223.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5139.23 2085.11 5139.23 2122.11 3918.62 2122.11 3918.62 495.61 5250.65 495.62 5250.65 568.59 5360.09 568.59 5360.09 2085.11 5139.23 2085.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1667.62 4319.73 226.15 4319.73 226.15 2878.94 1446.93 2878.95 1446.59 3025.9 1595.17 3025.9 1595.17 3062.89 1667.29 3062.89 1667.62 4319.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7169.14 2043.6 7169.14 2302.52 5763.13 2302.52 5763.13 491.09 7056.35 490.6 7057.11 638.53 7205.36 639.03 7204.6 2043.6 7169.14 2043.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1619.94,
    y: 458.23,
    width: 72.45,
    height: 35.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3359.43,
    y: 436.73,
    width: 182.65,
    height: 220.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5300.01,
    y: 447.53,
    width: 112.1,
    height: 74.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1643.45 2980.16 1643.45 3017.15 1715.57 3017.15 1715.57 2833.58 1495.16 2833.58 1495.16 2980.16 1643.45 2980.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7107.74,
    y: 442.26,
    width: 142.93,
    height: 148.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1622.73,
    y1: 532.22,
    x2: 1622.73,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1585.74,
    y1: 496.23,
    x2: 1585.74,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1548.75,
    y1: 496.23,
    x2: 1548.75,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1511.3,
    y1: 496.23,
    x2: 1511.31,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1474.32,
    y1: 496.23,
    x2: 1474.32,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1437.33,
    y1: 496.23,
    x2: 1437.33,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1400.34,
    y1: 496.23,
    x2: 1400.34,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1363.35,
    y1: 496.23,
    x2: 1363.35,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1326.36,
    y1: 496.23,
    x2: 1326.37,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1289.38,
    y1: 496.23,
    x2: 1289.38,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1252.39,
    y1: 496.23,
    x2: 1252.39,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1215.4,
    y1: 496.23,
    x2: 1215.4,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1178.41,
    y1: 496.23,
    x2: 1178.41,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1141.42,
    y1: 496.23,
    x2: 1141.43,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1104.44,
    y1: 496.23,
    x2: 1104.44,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1067.45,
    y1: 496.23,
    x2: 1067.45,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1030.46,
    y1: 496.23,
    x2: 1030.46,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 993.47,
    y1: 496.23,
    x2: 993.47,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 956.48,
    y1: 496.23,
    x2: 956.49,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 919.49,
    y1: 496.23,
    x2: 919.5,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 882.51,
    y1: 496.23,
    x2: 882.51,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 845.52,
    y1: 496.23,
    x2: 845.52,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 808.53,
    y1: 496.23,
    x2: 808.53,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.54,
    y1: 496.23,
    x2: 771.54,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 734.55,
    y1: 496.23,
    x2: 734.56,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 697.57,
    y1: 496.23,
    x2: 697.57,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 660.58,
    y1: 496.23,
    x2: 660.58,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 623.59,
    y1: 496.23,
    x2: 623.59,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 586.6,
    y1: 496.23,
    x2: 586.6,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 549.61,
    y1: 496.23,
    x2: 549.62,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 512.62,
    y1: 496.23,
    x2: 512.63,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475.64,
    y1: 496.23,
    x2: 475.64,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 438.65,
    y1: 496.23,
    x2: 438.65,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 401.66,
    y1: 496.23,
    x2: 401.66,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 364.67,
    y1: 496.23,
    x2: 364.67,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 327.68,
    y1: 496.23,
    x2: 327.69,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 290.7,
    y1: 496.23,
    x2: 290.7,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 253.71,
    y1: 496.23,
    x2: 253.71,
    y2: 2307.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 532.22,
    x2: 1659.71,
    y2: 532.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 569.21,
    x2: 1659.71,
    y2: 569.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 606.2,
    x2: 1659.71,
    y2: 606.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 643.18,
    x2: 1659.71,
    y2: 643.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 680.17,
    x2: 1659.71,
    y2: 680.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 717.16,
    x2: 1659.71,
    y2: 717.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 754.15,
    x2: 1659.71,
    y2: 754.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 791.14,
    x2: 1659.71,
    y2: 791.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 828.13,
    x2: 1659.71,
    y2: 828.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 865.11,
    x2: 1659.71,
    y2: 865.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 902.1,
    x2: 1659.71,
    y2: 902.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 939.09,
    x2: 1659.71,
    y2: 939.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 976.08,
    x2: 1659.71,
    y2: 976.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1013.07,
    x2: 1659.71,
    y2: 1013.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1050.05,
    x2: 1659.71,
    y2: 1050.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1087.04,
    x2: 1659.71,
    y2: 1087.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1124.03,
    x2: 1659.71,
    y2: 1124.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1161.02,
    x2: 1659.71,
    y2: 1161.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1198.01,
    x2: 1659.71,
    y2: 1198.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1235,
    x2: 1659.71,
    y2: 1235
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1271.98,
    x2: 1659.71,
    y2: 1271.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1308.97,
    x2: 1659.71,
    y2: 1308.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1345.96,
    x2: 1659.71,
    y2: 1345.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1382.95,
    x2: 1659.71,
    y2: 1382.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1419.94,
    x2: 1659.71,
    y2: 1419.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1456.92,
    x2: 1659.71,
    y2: 1456.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1493.91,
    x2: 1659.71,
    y2: 1493.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1530.9,
    x2: 1659.71,
    y2: 1530.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1567.89,
    x2: 1659.71,
    y2: 1567.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1604.88,
    x2: 1659.71,
    y2: 1604.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1641.86,
    x2: 1659.71,
    y2: 1641.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1678.85,
    x2: 1659.71,
    y2: 1678.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1715.84,
    x2: 1659.71,
    y2: 1715.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1752.83,
    x2: 1659.71,
    y2: 1752.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1789.82,
    x2: 1659.71,
    y2: 1789.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1826.81,
    x2: 1659.71,
    y2: 1826.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1863.79,
    x2: 1659.71,
    y2: 1863.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1900.78,
    x2: 1659.71,
    y2: 1900.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1937.77,
    x2: 1659.71,
    y2: 1937.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 1974.76,
    x2: 1659.71,
    y2: 1974.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 2011.75,
    x2: 1659.71,
    y2: 2011.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 2048.73,
    x2: 1659.71,
    y2: 2048.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 2085.72,
    x2: 1659.71,
    y2: 2085.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 2122.71,
    x2: 1659.71,
    y2: 2122.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 2159.7,
    x2: 1659.71,
    y2: 2159.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 2196.69,
    x2: 1659.71,
    y2: 2196.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 2233.68,
    x2: 1659.71,
    y2: 2233.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.72,
    y1: 2270.66,
    x2: 1659.71,
    y2: 2270.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1656.16,
    y1: 457.85,
    x2: 1656.16,
    y2: 494.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3453.75,
    y1: 702.85,
    x2: 3453.76,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3416.76,
    y1: 702.85,
    x2: 3416.77,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3379.78,
    y1: 702.85,
    x2: 3379.78,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3342.33,
    y1: 702.85,
    x2: 3342.34,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3305.34,
    y1: 486.43,
    x2: 3305.35,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3268.36,
    y1: 486.43,
    x2: 3268.36,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3231.37,
    y1: 486.43,
    x2: 3231.37,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3194.38,
    y1: 486.43,
    x2: 3194.38,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3157.39,
    y1: 486.43,
    x2: 3157.39,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3120.4,
    y1: 486.43,
    x2: 3120.41,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3083.42,
    y1: 486.43,
    x2: 3083.42,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3046.43,
    y1: 486.43,
    x2: 3046.43,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3009.44,
    y1: 486.43,
    x2: 3009.44,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2972.45,
    y1: 486.43,
    x2: 2972.45,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2935.46,
    y1: 486.43,
    x2: 2935.47,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2898.47,
    y1: 486.43,
    x2: 2898.48,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2861.49,
    y1: 486.43,
    x2: 2861.49,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2824.5,
    y1: 486.43,
    x2: 2824.5,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2787.51,
    y1: 486.43,
    x2: 2787.51,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2750.52,
    y1: 486.43,
    x2: 2750.52,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2713.53,
    y1: 486.43,
    x2: 2713.54,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2676.55,
    y1: 486.43,
    x2: 2676.55,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2639.56,
    y1: 486.43,
    x2: 2639.56,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2602.57,
    y1: 486.43,
    x2: 2602.57,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2565.58,
    y1: 486.43,
    x2: 2565.58,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2528.59,
    y1: 486.43,
    x2: 2528.6,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2491.6,
    y1: 486.43,
    x2: 2491.61,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2454.62,
    y1: 486.43,
    x2: 2454.62,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2417.63,
    y1: 486.43,
    x2: 2417.63,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2380.64,
    y1: 486.43,
    x2: 2380.64,
    y2: 2226.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2343.65,
    y1: 486.43,
    x2: 2343.65,
    y2: 2226.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2306.66,
    y1: 486.43,
    x2: 2306.67,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2269.68,
    y1: 486.43,
    x2: 2269.68,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2232.69,
    y1: 486.43,
    x2: 2232.69,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2195.7,
    y1: 486.43,
    x2: 2195.7,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2158.71,
    y1: 486.43,
    x2: 2158.71,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2121.72,
    y1: 486.43,
    x2: 2121.73,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2084.74,
    y1: 486.43,
    x2: 2084.74,
    y2: 2260.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 522.42,
    x2: 3305.34,
    y2: 522.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 559.41,
    x2: 3305.34,
    y2: 559.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 596.39,
    x2: 3305.34,
    y2: 596.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 633.38,
    x2: 3305.34,
    y2: 633.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 670.37,
    x2: 3305.34,
    y2: 670.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 707.36,
    x2: 3490.74,
    y2: 707.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 744.35,
    x2: 3490.74,
    y2: 744.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 781.33,
    x2: 3490.74,
    y2: 781.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 818.32,
    x2: 3490.74,
    y2: 818.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 855.31,
    x2: 3490.74,
    y2: 855.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 892.3,
    x2: 3490.74,
    y2: 892.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 929.29,
    x2: 3490.74,
    y2: 929.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 966.28,
    x2: 3490.74,
    y2: 966.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1003.26,
    x2: 3490.74,
    y2: 1003.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1040.25,
    x2: 3490.74,
    y2: 1040.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1077.24,
    x2: 3490.74,
    y2: 1077.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1114.23,
    x2: 3490.74,
    y2: 1114.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1151.22,
    x2: 3490.74,
    y2: 1151.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1188.2,
    x2: 3490.74,
    y2: 1188.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1225.19,
    x2: 3490.74,
    y2: 1225.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1262.18,
    x2: 3490.74,
    y2: 1262.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1299.17,
    x2: 3490.74,
    y2: 1299.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1336.16,
    x2: 3490.74,
    y2: 1336.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1373.15,
    x2: 3490.74,
    y2: 1373.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1410.13,
    x2: 3490.74,
    y2: 1410.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1447.12,
    x2: 3490.74,
    y2: 1447.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1484.11,
    x2: 3490.74,
    y2: 1484.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1521.1,
    x2: 3490.74,
    y2: 1521.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1558.09,
    x2: 3490.74,
    y2: 1558.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1595.07,
    x2: 3490.74,
    y2: 1595.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1632.06,
    x2: 3490.74,
    y2: 1632.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1669.05,
    x2: 3490.74,
    y2: 1669.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1706.04,
    x2: 3490.74,
    y2: 1706.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1743.03,
    x2: 3490.74,
    y2: 1743.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1780.02,
    x2: 3490.74,
    y2: 1780.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1817,
    x2: 3490.74,
    y2: 1817
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1853.99,
    x2: 3490.74,
    y2: 1853.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1890.98,
    x2: 3490.74,
    y2: 1890.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1927.97,
    x2: 3490.74,
    y2: 1927.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 1964.96,
    x2: 3490.74,
    y2: 1964.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 2001.94,
    x2: 3490.74,
    y2: 2001.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 2038.93,
    x2: 3490.74,
    y2: 2038.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 2075.92,
    x2: 3490.74,
    y2: 2075.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 2112.91,
    x2: 3489.98,
    y2: 2112.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 2149.9,
    x2: 3489.98,
    y2: 2149.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 2186.88,
    x2: 3489.98,
    y2: 2186.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2047.75,
    y1: 2223.87,
    x2: 3489.23,
    y2: 2223.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3396.2,
    y1: 436.73,
    x2: 3396.2,
    y2: 657.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3432.77,
    y1: 436.73,
    x2: 3432.77,
    y2: 657.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3468.35,
    y1: 436.73,
    x2: 3468.35,
    y2: 657.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3504.92,
    y1: 436.73,
    x2: 3504.92,
    y2: 657.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5324.63,
    y1: 564.07,
    x2: 5324.63,
    y2: 2085.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5287.64,
    y1: 569.34,
    x2: 5287.64,
    y2: 2085.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5250.65,
    y1: 495.62,
    x2: 5250.65,
    y2: 2085.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5213.2,
    y1: 495.62,
    x2: 5213.21,
    y2: 2085.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5176.22,
    y1: 495.62,
    x2: 5176.22,
    y2: 2085.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5139.23,
    y1: 495.62,
    x2: 5139.23,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5102.24,
    y1: 495.62,
    x2: 5102.24,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5065.25,
    y1: 495.62,
    x2: 5065.25,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5028.26,
    y1: 495.62,
    x2: 5028.27,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4991.28,
    y1: 495.62,
    x2: 4991.28,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4954.29,
    y1: 495.62,
    x2: 4954.29,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4917.3,
    y1: 495.62,
    x2: 4917.3,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4880.31,
    y1: 495.62,
    x2: 4880.31,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4843.32,
    y1: 495.62,
    x2: 4843.33,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4806.33,
    y1: 495.62,
    x2: 4806.34,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4769.35,
    y1: 495.62,
    x2: 4769.35,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4732.36,
    y1: 495.62,
    x2: 4732.36,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4695.37,
    y1: 495.62,
    x2: 4695.37,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4658.38,
    y1: 495.62,
    x2: 4658.38,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4621.39,
    y1: 495.62,
    x2: 4621.4,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4584.41,
    y1: 495.62,
    x2: 4584.41,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4547.42,
    y1: 495.62,
    x2: 4547.42,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4510.43,
    y1: 495.62,
    x2: 4510.43,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4473.44,
    y1: 495.62,
    x2: 4473.44,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4436.45,
    y1: 495.62,
    x2: 4436.46,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4399.47,
    y1: 495.62,
    x2: 4399.47,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4362.48,
    y1: 495.62,
    x2: 4362.48,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4325.49,
    y1: 495.62,
    x2: 4325.49,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4288.5,
    y1: 495.62,
    x2: 4288.5,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4251.51,
    y1: 495.62,
    x2: 4251.51,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4214.52,
    y1: 495.62,
    x2: 4214.53,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4177.54,
    y1: 495.62,
    x2: 4177.54,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4140.55,
    y1: 495.62,
    x2: 4140.55,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4103.56,
    y1: 495.62,
    x2: 4103.56,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4066.57,
    y1: 495.62,
    x2: 4066.57,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4029.58,
    y1: 495.62,
    x2: 4029.59,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3992.6,
    y1: 495.62,
    x2: 3992.6,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3955.61,
    y1: 495.62,
    x2: 3955.61,
    y2: 2122.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 531.61,
    x2: 5248.56,
    y2: 531.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 568.59,
    x2: 5248.56,
    y2: 568.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 605.58,
    x2: 5361.61,
    y2: 605.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 642.57,
    x2: 5361.61,
    y2: 642.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 679.56,
    x2: 5361.61,
    y2: 679.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 716.55,
    x2: 5361.61,
    y2: 716.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 753.54,
    x2: 5361.61,
    y2: 753.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 790.52,
    x2: 5361.61,
    y2: 790.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 827.51,
    x2: 5361.61,
    y2: 827.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 864.5,
    x2: 5361.61,
    y2: 864.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 901.49,
    x2: 5361.61,
    y2: 901.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 938.48,
    x2: 5361.61,
    y2: 938.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 975.46,
    x2: 5361.61,
    y2: 975.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1012.45,
    x2: 5361.61,
    y2: 1012.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1049.44,
    x2: 5361.61,
    y2: 1049.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1086.43,
    x2: 5361.61,
    y2: 1086.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1123.42,
    x2: 5361.61,
    y2: 1123.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1160.41,
    x2: 5361.61,
    y2: 1160.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1197.39,
    x2: 5361.61,
    y2: 1197.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1234.38,
    x2: 5361.61,
    y2: 1234.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1271.37,
    x2: 5361.61,
    y2: 1271.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1308.36,
    x2: 5361.61,
    y2: 1308.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1345.35,
    x2: 5361.61,
    y2: 1345.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1382.33,
    x2: 5361.61,
    y2: 1382.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1419.32,
    x2: 5361.61,
    y2: 1419.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1456.31,
    x2: 5361.61,
    y2: 1456.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1493.3,
    x2: 5361.61,
    y2: 1493.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1530.29,
    x2: 5361.61,
    y2: 1530.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1567.27,
    x2: 5361.61,
    y2: 1567.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1604.26,
    x2: 5361.61,
    y2: 1604.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1641.25,
    x2: 5361.61,
    y2: 1641.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1678.24,
    x2: 5361.61,
    y2: 1678.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1715.23,
    x2: 5361.61,
    y2: 1715.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1752.22,
    x2: 5361.61,
    y2: 1752.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1789.2,
    x2: 5361.61,
    y2: 1789.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1826.19,
    x2: 5361.61,
    y2: 1826.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1863.18,
    x2: 5361.61,
    y2: 1863.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1900.17,
    x2: 5361.61,
    y2: 1900.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1937.16,
    x2: 5361.61,
    y2: 1937.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 1974.14,
    x2: 5361.61,
    y2: 1974.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3918.62,
    y1: 2011.13,
    x2: 5361.61,
    y2: 2011.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3917.35,
    y1: 2048.12,
    x2: 5360.34,
    y2: 2048.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3917.35,
    y1: 2085.11,
    x2: 5360.34,
    y2: 2085.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5337.57,
    y1: 447.53,
    x2: 5337.57,
    y2: 521.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5375.12,
    y1: 447.53,
    x2: 5375.12,
    y2: 521.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1632.16,
    y1: 3062.89,
    x2: 1632.16,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1595.17,
    y1: 3025.9,
    x2: 1595.17,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1558.18,
    y1: 3025.9,
    x2: 1558.18,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1520.74,
    y1: 3025.9,
    x2: 1520.74,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1483.75,
    y1: 3025.9,
    x2: 1483.75,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1446.76,
    y1: 2878.95,
    x2: 1446.76,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1409.77,
    y1: 2878.95,
    x2: 1409.78,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1372.79,
    y1: 2878.95,
    x2: 1372.79,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1335.8,
    y1: 2878.95,
    x2: 1335.8,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1298.81,
    y1: 2878.95,
    x2: 1298.81,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1261.82,
    y1: 2878.95,
    x2: 1261.82,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1224.83,
    y1: 2878.95,
    x2: 1224.84,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1187.84,
    y1: 2878.95,
    x2: 1187.85,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.86,
    y1: 2878.95,
    x2: 1150.86,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1113.87,
    y1: 2878.95,
    x2: 1113.87,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1076.88,
    y1: 2878.95,
    x2: 1076.88,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1039.89,
    y1: 2878.95,
    x2: 1039.89,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1002.9,
    y1: 2878.95,
    x2: 1002.91,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 965.92,
    y1: 2878.95,
    x2: 965.92,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 928.93,
    y1: 2878.95,
    x2: 928.93,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 891.94,
    y1: 2878.95,
    x2: 891.94,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 854.95,
    y1: 2878.95,
    x2: 854.95,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 817.96,
    y1: 2878.95,
    x2: 817.97,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 780.97,
    y1: 2878.95,
    x2: 780.98,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 743.99,
    y1: 2878.95,
    x2: 743.99,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 707,
    y1: 2878.95,
    x2: 707,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 670.01,
    y1: 2878.95,
    x2: 670.01,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 633.02,
    y1: 2878.95,
    x2: 633.02,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 596.03,
    y1: 2878.95,
    x2: 596.04,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 559.05,
    y1: 2878.95,
    x2: 559.05,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 522.06,
    y1: 2878.95,
    x2: 522.06,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 485.07,
    y1: 2878.95,
    x2: 485.07,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 448.08,
    y1: 2878.95,
    x2: 448.08,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 411.09,
    y1: 2878.95,
    x2: 411.1,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.11,
    y1: 2878.95,
    x2: 374.11,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 337.12,
    y1: 2878.95,
    x2: 337.12,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 300.13,
    y1: 2878.95,
    x2: 300.13,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 263.14,
    y1: 2878.95,
    x2: 263.14,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 2878.95,
    x2: 226.15,
    y2: 4319.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 2914.94,
    x2: 1446.12,
    y2: 2914.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 2951.92,
    x2: 1446.12,
    y2: 2951.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 2988.91,
    x2: 1446.12,
    y2: 2988.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3025.9,
    x2: 1669.15,
    y2: 3025.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3062.89,
    x2: 1669.15,
    y2: 3062.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3099.88,
    x2: 1669.15,
    y2: 3099.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3136.86,
    x2: 1669.15,
    y2: 3136.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3173.85,
    x2: 1669.15,
    y2: 3173.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3210.84,
    x2: 1669.15,
    y2: 3210.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3247.83,
    x2: 1669.15,
    y2: 3247.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3284.82,
    x2: 1669.15,
    y2: 3284.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3321.81,
    x2: 1669.15,
    y2: 3321.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3358.79,
    x2: 1669.15,
    y2: 3358.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3395.78,
    x2: 1669.15,
    y2: 3395.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3432.77,
    x2: 1669.15,
    y2: 3432.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3469.76,
    x2: 1669.15,
    y2: 3469.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3506.75,
    x2: 1669.15,
    y2: 3506.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3543.73,
    x2: 1669.15,
    y2: 3543.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3580.72,
    x2: 1669.15,
    y2: 3580.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3617.71,
    x2: 1669.15,
    y2: 3617.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3654.7,
    x2: 1669.15,
    y2: 3654.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3691.69,
    x2: 1669.15,
    y2: 3691.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3728.68,
    x2: 1669.15,
    y2: 3728.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3765.66,
    x2: 1669.15,
    y2: 3765.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3802.65,
    x2: 1669.15,
    y2: 3802.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3839.64,
    x2: 1669.15,
    y2: 3839.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3876.63,
    x2: 1669.15,
    y2: 3876.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3913.62,
    x2: 1669.15,
    y2: 3913.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3950.6,
    x2: 1669.15,
    y2: 3950.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 3987.59,
    x2: 1669.15,
    y2: 3987.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 4024.58,
    x2: 1669.15,
    y2: 4024.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 4061.57,
    x2: 1669.15,
    y2: 4061.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 4098.56,
    x2: 1669.15,
    y2: 4098.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 4135.55,
    x2: 1669.15,
    y2: 4135.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 4172.53,
    x2: 1669.15,
    y2: 4172.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 4209.52,
    x2: 1669.15,
    y2: 4209.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 4246.51,
    x2: 1669.15,
    y2: 4246.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.15,
    y1: 4283.5,
    x2: 1669.15,
    y2: 4283.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1789.41,
    y1: 2860.56,
    x2: 1789.41,
    y2: 2897.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3543.24,
    y1: 472.26,
    x2: 3359.43,
    y2: 472.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3543.24,
    y1: 508.84,
    x2: 3359.43,
    y2: 508.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3543.24,
    y1: 544.41,
    x2: 3359.43,
    y2: 544.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3543.24,
    y1: 580.99,
    x2: 3359.43,
    y2: 580.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3542.66,
    y1: 619.11,
    x2: 3358.85,
    y2: 619.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5413.11,
    y1: 482.92,
    x2: 5298.18,
    y2: 482.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5403.11,
    y1: 530.47,
    x2: 5288.18,
    y2: 530.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7169.13,
    y1: 634.66,
    x2: 7169.14,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7132.15,
    y1: 634.66,
    x2: 7132.15,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7095.16,
    y1: 634.66,
    x2: 7095.16,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7057.71,
    y1: 634.66,
    x2: 7057.72,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7020.73,
    y1: 491.1,
    x2: 7020.73,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6983.74,
    y1: 491.1,
    x2: 6983.74,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6946.75,
    y1: 491.1,
    x2: 6946.75,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6909.76,
    y1: 491.1,
    x2: 6909.76,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6872.77,
    y1: 491.1,
    x2: 6872.78,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6835.78,
    y1: 491.1,
    x2: 6835.79,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6798.8,
    y1: 491.1,
    x2: 6798.8,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6761.81,
    y1: 491.1,
    x2: 6761.81,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6724.82,
    y1: 491.1,
    x2: 6724.82,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6687.83,
    y1: 491.1,
    x2: 6687.83,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6650.84,
    y1: 491.1,
    x2: 6650.85,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6613.86,
    y1: 491.1,
    x2: 6613.86,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6576.87,
    y1: 491.1,
    x2: 6576.87,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6539.88,
    y1: 491.1,
    x2: 6539.88,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6502.89,
    y1: 491.1,
    x2: 6502.89,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6465.9,
    y1: 491.1,
    x2: 6465.91,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6428.91,
    y1: 491.1,
    x2: 6428.92,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6391.93,
    y1: 491.1,
    x2: 6391.93,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6354.94,
    y1: 491.1,
    x2: 6354.94,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6317.95,
    y1: 491.1,
    x2: 6317.95,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6280.96,
    y1: 491.1,
    x2: 6280.96,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6243.97,
    y1: 491.1,
    x2: 6243.98,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6206.99,
    y1: 491.1,
    x2: 6206.99,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6170,
    y1: 491.1,
    x2: 6170,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6133.01,
    y1: 491.1,
    x2: 6133.01,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6096.02,
    y1: 491.1,
    x2: 6096.02,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6059.03,
    y1: 491.1,
    x2: 6059.04,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6022.05,
    y1: 491.1,
    x2: 6022.05,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5985.06,
    y1: 491.1,
    x2: 5985.06,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5948.07,
    y1: 491.1,
    x2: 5948.07,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5911.08,
    y1: 491.1,
    x2: 5911.08,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5874.09,
    y1: 491.1,
    x2: 5874.09,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5837.1,
    y1: 491.1,
    x2: 5837.11,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5800.12,
    y1: 491.1,
    x2: 5800.12,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 491.1,
    x2: 5763.13,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 527.09,
    x2: 7056.91,
    y2: 527.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 564.07,
    x2: 7056.91,
    y2: 564.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 601.06,
    x2: 7056.91,
    y2: 601.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 638.05,
    x2: 7056.91,
    y2: 638.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 675.04,
    x2: 7205.34,
    y2: 675.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 712.03,
    x2: 7206.12,
    y2: 712.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 749.01,
    x2: 7206.12,
    y2: 749.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 786,
    x2: 7206.12,
    y2: 786
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 822.99,
    x2: 7206.12,
    y2: 822.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 859.98,
    x2: 7206.12,
    y2: 859.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 896.97,
    x2: 7206.12,
    y2: 896.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 933.96,
    x2: 7206.12,
    y2: 933.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 970.94,
    x2: 7206.12,
    y2: 970.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1007.93,
    x2: 7206.12,
    y2: 1007.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1044.92,
    x2: 7206.12,
    y2: 1044.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1081.91,
    x2: 7206.12,
    y2: 1081.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1118.9,
    x2: 7206.12,
    y2: 1118.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1155.88,
    x2: 7206.12,
    y2: 1155.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1192.87,
    x2: 7206.12,
    y2: 1192.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1229.86,
    x2: 7206.12,
    y2: 1229.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1266.85,
    x2: 7206.12,
    y2: 1266.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1303.84,
    x2: 7206.12,
    y2: 1303.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1340.83,
    x2: 7206.12,
    y2: 1340.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1377.81,
    x2: 7206.12,
    y2: 1377.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1414.8,
    x2: 7206.12,
    y2: 1414.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1451.79,
    x2: 7206.12,
    y2: 1451.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1488.78,
    x2: 7206.12,
    y2: 1488.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1525.77,
    x2: 7206.12,
    y2: 1525.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1562.75,
    x2: 7206.12,
    y2: 1562.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1599.74,
    x2: 7206.12,
    y2: 1599.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1636.73,
    x2: 7206.12,
    y2: 1636.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1673.72,
    x2: 7206.12,
    y2: 1673.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1710.71,
    x2: 7206.12,
    y2: 1710.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1747.69,
    x2: 7206.12,
    y2: 1747.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1784.68,
    x2: 7206.12,
    y2: 1784.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1821.67,
    x2: 7206.12,
    y2: 1821.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1858.66,
    x2: 7206.12,
    y2: 1858.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1895.65,
    x2: 7206.12,
    y2: 1895.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1932.64,
    x2: 7206.12,
    y2: 1932.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 1969.62,
    x2: 7206.12,
    y2: 1969.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 2006.61,
    x2: 7206.12,
    y2: 2006.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 2043.6,
    x2: 7206.12,
    y2: 2043.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 2080.59,
    x2: 7206.12,
    y2: 2080.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 2117.58,
    x2: 7169.13,
    y2: 2117.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 2154.56,
    x2: 7169.13,
    y2: 2154.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 2191.55,
    x2: 7169.13,
    y2: 2191.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 2228.54,
    x2: 7169.13,
    y2: 2228.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 2265.53,
    x2: 7169.13,
    y2: 2265.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5763.13,
    y1: 2302.52,
    x2: 7169.13,
    y2: 2302.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7144.51,
    y1: 442.26,
    x2: 7144.51,
    y2: 591.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7181.08,
    y1: 442.26,
    x2: 7181.08,
    y2: 591.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7216.66,
    y1: 442.26,
    x2: 7216.66,
    y2: 591.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7250.67,
    y1: 477.81,
    x2: 7107.61,
    y2: 477.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7250.67,
    y1: 514.39,
    x2: 7107.61,
    y2: 514.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7250.22,
    y1: 552.5,
    x2: 7107.16,
    y2: 552.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1530.52,
    y1: 2833.58,
    x2: 1530.52,
    y2: 2980.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1566.61,
    y1: 2833.58,
    x2: 1566.61,
    y2: 2980.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1603.69,
    y1: 2833.58,
    x2: 1603.69,
    y2: 2980.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1640.78,
    y1: 2833.58,
    x2: 1640.78,
    y2: 2980.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1715.57,
    y1: 2869.27,
    x2: 1495.16,
    y2: 2869.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1715.57,
    y1: 2906.23,
    x2: 1495.16,
    y2: 2906.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1715.57,
    y1: 2945.2,
    x2: 1495.16,
    y2: 2945.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1715.57,
    y1: 2982.16,
    x2: 1640.78,
    y2: 2982.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1678.87,
    y1: 2833.58,
    x2: 1678.87,
    y2: 3018.16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsDesktopVd);
export default __webpack_public_path__ + "static/media/results-desktop-vd.43dd371755de7048045bf780ba1cb0e8.svg";
export { ForwardRef as ReactComponent };